import axios from './providers/axios';

const moodService = {
    getMoods() {
        return axios.get(`/v1/admin/company/mood/store`);
    },
    updateOrder(data) {
        return axios.post('/v1/admin/company/mood/updateOrder', data);
    },
    updateMood(data) {
        return axios.post(`/v1/admin/company/mood/update`, data);
    }
}

export default moodService;
